// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"96":"41e1a4c6","159":"42579742","346":"0595b317","354":"3a622fb5","453":"73b50fca","459":"6dc78312","633":"ca1f1d01","899":"8e45eb69"}[chunkId] + ".chunk.js";
};